import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '../api/contracts/product';
import { map, Observable } from 'rxjs';
import { CartService } from '../services/cart.service';

@Pipe({
  name: 'getInStoreCartItemQuantity',
})
export class GetInStoreCartItemQuantityPipe implements PipeTransform {
  constructor(private readonly cartService: CartService) {}

  transform(product: Product): Observable<number> {
    return this.cartService.currentCart$.pipe(
      map(
        (cart) =>
          cart.items.find((i) => i.product.id === product.id)?.quantity || 0
      )
    );
  }
}
